module.exports = __webpack_public_path__ + "assets/webproduction-ace0dae709a7faf365acb27f97a3a1ff.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Helpdesk/assets/webproduction.png
// module id = 634
// module chunks = 0 1